import * as ss from 'superstruct';
import { ExampleResource } from './example.resource';
import { AuResourceName } from './types';
import { UserResource } from './user.resource';
import { ConversionResource } from './conversions/conversion.resource';
import { ConversionFilterListResource } from './conversions/filter/conversion-filter-list';
import {
  ConversionInputStreamResource,
  ConversionOutputStreamConsumptionEventResource,
  ConversionOutputStreamResource,
  CustomTrackingParamResource,
  FunnelStageAssignmentResource,
  FunnelStageResource,
  PaidSourceResource,
  TrackedCallResource,
  TrackedUrlResource,
} from './conversions';
import { DashboardResource } from './dashboard.resource';
import { RetainerResource } from './retainer';
import { AdAccountResource, AdDataStreamResource } from './ad-platforms';
import { IntegrationConnectionResource } from './connected-accounts';

export const AuResourceNameToStructMap = {
  examples: ExampleResource,
  users: UserResource,
  ['dashboard']: DashboardResource,
  ['conversion']: ConversionResource,
  ['conversion-filter']: ConversionFilterListResource,
  ['conversion-output-stream']: ConversionOutputStreamResource,
  ['conversion-output-stream-consumption-event']:
    ConversionOutputStreamConsumptionEventResource,
  ['paid-source']: PaidSourceResource,
  ['retainer']: RetainerResource,
  ['tracked-call']: TrackedCallResource,
  ['tracked-url']: TrackedUrlResource,
  ['funnel-stage']: FunnelStageResource,
  ['funnel-stage-assignment']: FunnelStageAssignmentResource,
  ['custom-tracking-param']: CustomTrackingParamResource,
  ['conversion-input-stream']: ConversionInputStreamResource,
  ['ad-account']: AdAccountResource,
  ['ad-data-stream']: AdDataStreamResource,
  ['integration-connection']: IntegrationConnectionResource,
} as const satisfies Record<AuResourceName, ss.Struct<any, any>>;

export type AuResourceNameToStructMap = typeof AuResourceNameToStructMap;

export type AuResourceNameToTypeMap = {
  [N in AuResourceName]: AuResourceNameToStructMap[N]['TYPE'];
};
